var BPChecksFieldKey;
(function (BPChecksFieldKey) {
    BPChecksFieldKey[BPChecksFieldKey["skillsDecision"] = 'SKILLS'] = "skillsDecision";
    BPChecksFieldKey[BPChecksFieldKey["valDecision"] = 'VAL'] = "valDecision";
    BPChecksFieldKey[BPChecksFieldKey["taDecision"] = 'BPATA.TA'] = "taDecision";
    BPChecksFieldKey[BPChecksFieldKey["bpaDecision"] = 'BPATA.BPA'] = "bpaDecision";
    BPChecksFieldKey[BPChecksFieldKey["solDecision"] = 'SOL'] = "solDecision";
    BPChecksFieldKey[BPChecksFieldKey["compDecision"] = 'COMP'] = "compDecision";
})(BPChecksFieldKey || (BPChecksFieldKey = {}));
var DetailTableBpAuthorizationController = (function () {
    function DetailTableBpAuthorizationController(topic, settings, socket, $injector, env, $timeout, $scope, $attrs, Dialog) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.Dialog = Dialog;
        this.tableName = 'BP Authorization';
        this.bpaProps = ["Approved", "Not Approved"].map(function (e) { return ({ abbrev: e }); });
        this.taProps = ["Approved", "Not Approved", "Not Required"].map(function (e) { return ({ abbrev: e }); });
        this.valuesProps = ["Yes", "No"].map(function (e) { return ({ abbrev: e }); });
        this.stateList = [];
        this.stateListCopy = [];
        this.OPP_VERSION_5 = 5;
        this.isTableEditMode = false;
        this.comp = "bpAuth";
        this.socket.forward('eligibility.getBpAuthorizationData', this.$scope);
        this.$scope.$on('socket:eligibility.getBpAuthorizationData', function (event, data) {
            _this.tableHeader = data.header;
            _this.tableRows = data.rows;
            _this.tableError = _.get(data, "err", '');
            _this.checkIfRowFails();
        });
        this.socket.forward('topic.update.partial', this.$scope);
        this.$scope.$on('socket:topic.update.partial', function (event, data) {
            _this.updateDealRegProductGroupData();
        });
    }
    DetailTableBpAuthorizationController.prototype.$onInit = function () {
        this.getBpAuthorizationData();
    };
    DetailTableBpAuthorizationController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    DetailTableBpAuthorizationController.prototype.changeTableEditMode = function (isEdit) {
        this.isTableEditMode = isEdit;
    };
    DetailTableBpAuthorizationController.prototype.edit = function () {
        this.stateListCopy = _.cloneDeep(this.stateList);
        this.changeTableEditMode(true);
    };
    DetailTableBpAuthorizationController.prototype.cancel = function () {
        this.stateList = this.stateListCopy;
        this.changeTableEditMode(false);
    };
    DetailTableBpAuthorizationController.prototype.getBpAuthorizationData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBpAuthorizationData',
                script: '/detail/eligibility/bpAuthorization/index',
                data: {
                    oppName: this.topic.topic._id
                },
                token: this.env.user.token
            }
        });
    };
    DetailTableBpAuthorizationController.prototype.isEditButtonEnabled = function () {
        return !this.isAllCompletedAutomatically() &&
            this.topic.editableComponents[this.comp] && !this.topic.editableComponents[this.comp].socket;
    };
    DetailTableBpAuthorizationController.prototype.displayValueDecision = function (fieldValue, key, stateFieldName) {
        return (fieldValue !== 'Manual Review' && !this.isBPATAExistInCloudant) ||
            (this.isBPATAExistInCloudant && !_.get(this, "stateList[" + key + "][" + stateFieldName + "].isManualReview"));
    };
    DetailTableBpAuthorizationController.prototype.isAllCompletedAutomatically = function () {
        var notAutoFound = false;
        for (var i = 0; i < this.tableRows.length; i++) {
            if (!this.isCompletedAutomatically(this.tableRows[i], i)) {
                notAutoFound = true;
                break;
            }
        }
        return !notAutoFound;
    };
    DetailTableBpAuthorizationController.prototype.isCompletedAutomatically = function (value, key) {
        var result = (value.bpAgreement !== 'Manual Review' &&
            value.transactionAgreement !== 'Manual Review' &&
            value.competency !== 'Manual Review' &&
            value.skills !== 'Manual Review' &&
            value.solution !== 'Manual Review' &&
            value.valueDecision !== 'Manual Review' && !this.isBPATAExistInCloudant)
            || (this.isBPATAExistInCloudant &&
                !_.get(this, "stateList[" + key + "].bpaDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].compDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].skillsDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].solDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].taDecision.isManualReview") &&
                !_.get(this, "stateList[" + key + "].valDecision.isManualReview"));
        return result;
    };
    DetailTableBpAuthorizationController.prototype.isRowCompleted = function (key) {
        return !(!_.get(this, "stateList[" + key + "].comments") ||
            !_.get(this, "stateList[" + key + "].bpaDecision.value") ||
            !_.get(this, "stateList[" + key + "].compDecision.value") ||
            !_.get(this, "stateList[" + key + "].skillsDecision.value") ||
            !_.get(this, "stateList[" + key + "].solDecision.value") ||
            !_.get(this, "stateList[" + key + "].taDecision.value") ||
            !_.get(this, "stateList[" + key + "].valDecision.value"));
    };
    DetailTableBpAuthorizationController.prototype.checkIfRowFails = function () {
        var _this = this;
        this.bpAuthorizationResults = _.get(this.topic.topic, "eligibility.bpAuthorization");
        this.isBPATAExistInCloudant = !!this.bpAuthorizationResults;
        this.stateList = this.tableRows.map(function (row, index) {
            if (_this.bpAuthorizationResults) {
                return _this.bpAuthorizationResults[index];
            }
            var obj = {
                bpaDecision: { isManualReview: false, value: row.bpAgreement },
                comments: '',
                compDecision: { isManualReview: false, value: row.competency },
                // isFinal: false,
                level2Label: row.gbt20ID,
                skillsDecision: { isManualReview: false, value: row.skills },
                solDecision: { isManualReview: false, value: row.solution },
                solutionId: row.dealRegProductGroupID,
                taDecision: { isManualReview: false, value: row.transactionAgreement },
                valDecision: { isManualReview: false, value: row.valueDecision }
            };
            if (row.bpAgreement === 'Manual Review') {
                obj.bpaDecision = Object.assign(obj.bpaDecision, { value: '', isManualReview: true });
            }
            if (row.transactionAgreement === 'Manual Review') {
                obj.taDecision = Object.assign(obj.taDecision, { value: '', isManualReview: true });
            }
            if (row.skills === 'Manual Review') {
                obj.skillsDecision = Object.assign(obj.skillsDecision, { value: '', isManualReview: true });
            }
            if (row.competency === 'Manual Review') {
                obj.compDecision = Object.assign(obj.compDecision, { value: '', isManualReview: true });
            }
            if (row.solution === 'Manual Review') {
                obj.solDecision = Object.assign(obj.solDecision, { value: '', isManualReview: true });
            }
            if (row.valueDecision === 'Manual Review') {
                obj.valDecision = Object.assign(obj.valDecision, { value: '', isManualReview: true });
            }
            return obj;
        });
    };
    DetailTableBpAuthorizationController.prototype.save = function () {
        var updatedTable = [];
        for (var i = 0; i < this.tableRows.length; i++) {
            var row = this.prepareToUpload(i);
            updatedTable.push(row);
        }
        var updateData = {
            isBpAuthOrDupCheckResult: true,
            opportunityId: this.topic.topic._id.substring(4),
            table: updatedTable
        };
        this.uploadResults({ "bpAuthorization": this.stateListObj }, updateData);
        this.changeTableEditMode(false);
    };
    DetailTableBpAuthorizationController.prototype.prepareToUpload = function (key) {
        // Return object of objects with index and change flag to true for current stateList
        this.stateListObj = this.stateList.reduce(function (obj, el, index) {
            // if (index === key) {
            //     el.isFinal = true;
            // }
            return Object.assign(obj, (_a = {}, _a[index] = el, _a));
            var _a;
        }, {});
        var check = {
            BPA: this.stateList[key].bpaDecision.value,
            COMP: this.stateList[key].compDecision.value,
            SKILLS: this.stateList[key].skillsDecision.value,
            SOL: this.stateList[key].solDecision.value,
            TA: this.stateList[key].taDecision.value,
            VAL: this.stateList[key].valDecision.value,
            level2Label: this.stateList[key].level2Label,
            solutionId: this.stateList[key].solutionId
        };
        return check;
    };
    DetailTableBpAuthorizationController.prototype.uploadResults = function (itemToUpdate, table) {
        var data = {
            data: (_a = {},
                _a['eligibility'] = {
                    add: true,
                    data: itemToUpdate
                },
                _a
            ),
            id: this.topic.topic._id,
            type: ['eligibility']
        };
        this.topic.updateServerTopic('couchUpdate', data, true, table);
        var _a;
    };
    /**
     * Update TA in Deal Registration Product Group table
     * @param {any} itemToUpdate
     */
    DetailTableBpAuthorizationController.prototype.updateDealRegProductGroupData = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    oppName: this.topic.topic._id.substring(4)
                },
                function: 'getDealRegProductGroupData',
                script: '/detail/eligibility/drpgResult/index',
                token: this.env.user.token
            }
        });
    };
    DetailTableBpAuthorizationController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$scope', '$attrs', 'Dialog', '_'];
    return DetailTableBpAuthorizationController;
}());
var DetailTableBpAuthorizationComponent = (function () {
    function DetailTableBpAuthorizationComponent() {
        this.templateUrl = 'detail-table-bp-authorization.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableBpAuthorizationController;
    }
    return DetailTableBpAuthorizationComponent;
}());
angular
    .module('application')
    .component('detailTableBpAuthorization', new DetailTableBpAuthorizationComponent());

//# sourceMappingURL=detail.table.bp.authorization.component.js.map
